import { message } from "antd";

export interface TokenProps {
  address: string;
  symbol: string;
  decimals: number;
  image: string;
}

declare global {
  interface Window {
    ethereum?: any;
  }
}

export const addTokenToWallet = async (props: TokenProps) => {
  const { address, symbol, decimals, image } = props;
  const provider = window.ethereum;

  if (!provider) {
    message.error({
      type: "error",
      content: "MetaMask is not installed.",
      className: "custom-class",
      duration: 2,
    });
    return;
  }

  try {
    const wasAdded = await provider.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address,
          symbol,
          decimals,
          image,
        },
      },
    });

    if (wasAdded) {
      message.success({
        type: "success",
        content: "Token added to wallet successfully!",
        className: "custom-class",
        duration: 2,
      });
    } else {
      message.warning({
        type: "warning",
        content: "User denied adding the token.",
        className: "custom-class",
        duration: 2,
      });
    }
  } catch (error: any) {
    message.error({
      type: "error",
      content: error?.message || "An error occurred while adding the token.",
      className: "custom-class",
      duration: 2,
    });
  }
};
